/**
 * Create a CsForm string length validator
 *
 * Enabling opts.allowEmpty along with opts.min can be done for optional fields that need
 * a minimum length checked when a value is provided. 
 *
 * @param {boolean} opts.allowEmpty - If falsey values are acceptable
 * @param {number}  opts.max        - Max character length allowed
 * @param {number}  opts.min        - Min character length allowed
 */
export const makeLengthValidator = ({allowEmpty = true, max = null, min = null}:{allowEmpty?: boolean, max?: number, min?: number}) => ({
    check      : (str:string) => (
        allowEmpty && !str
        || str && (
            (max !== null && str.length <= max)
            || (min !== null && str.length >= min)
        ) 
    ),
    getMessage : (() => {
        let lengthDescription:string;
        switch ((Number(max !== null) << 1) + Number(min !== null)) {
            case 3: lengthDescription = `between ${min} and ${max}`; break;
            case 2: lengthDescription = `at most ${max}`; break;
            case 1: lengthDescription = `at least ${min}`; break;
        }
        return () => `The length of this field must be ${lengthDescription} characters`;
    })(),
});

